import Vue from 'vue'
import Vuex from 'vuex'
// import middlewares from './middlewares'

import generalSession from './modules/general/session.js'
import generalOrganization from './modules/general/organizationSimpleTree.js'
import overrideSettings from './modules/general/overrideSettings.js'
import overrideInventorySettings from './modules/general/overrideInventorySettings.js'
import overrideOm61InventorySettings from './modules/general/overrideOm61InventorySettings.js'
import overrideTariffSettings from './modules/general/overrideTariffSettings.js'
import overrideAcceptablesSetting from './modules/general/overrideAcceptablesSetting.js'
import overrideMinimumOrderCoinRollsSettings from './modules/general/overrideMinimumOrderCoinRollsSettings.js'
import overrideCoinDistributionSetting from './modules/general/overrideCoinDistributionSetting.js'
import denominationForCurrency from './modules/general/denominationForCurrency'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    generalSession,
    generalOrganization,
    overrideSettings,
    overrideInventorySettings,
    overrideOm61InventorySettings,
    overrideTariffSettings,
    overrideAcceptablesSetting,
    overrideMinimumOrderCoinRollsSettings,
    overrideCoinDistributionSetting,
    denominationForCurrency
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js